const BRAND_DEFAULT = 'Kanban Zone';

export const getBrandName = () => {
  if (typeof window === 'undefined') {
    return BRAND_DEFAULT;
  }

  const host = window.location.host.toLowerCase();

  if (host.includes('greenline.works')) {
    return 'GreenLine';
  }

  if (host.includes('kanbanzone.io')) {
    return 'Kanban Zone';
  }

  return BRAND_DEFAULT;
};

